import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import TagManager from 'react-gtm-module';
import LogRocket from 'logrocket';
import moment from 'moment';
import 'moment/locale/pt-br';
import numeral from 'numeral';

import App from './App';
import * as serviceWorker from './serviceWorker';
import { isUnderMaintenance } from './services/MaintenanceServices';
import Maintenance from './components/common/Maintenance';

numeral.defaultFormat('$ 0,0.00');
numeral.register('locale', 'pt-BR', {
  delimiters: { thousands: '.', decimal: ',' },
  currency: { symbol: 'R$' },
});
numeral.locale('pt-BR');
moment.locale('pt-br');

const TMArgs = {
  gtmId: process.env.REACT_APP_GTM_KEY,
};

TagManager.initialize(TMArgs);

if (process.env.REACT_APP_ENVIRONMENT === 'production') {
  LogRocket.init(process.env.REACT_APP_LOGROCKET_ID, {
    rootHostname: process.env.REACT_APP_DOMAIN,
    network: {
      requestSanitizer: request => {
        // remove auth headers from log
        request.headers.Authorization = null;

        // if it's an authentication url, we don't record the sensitive data
        if (request.url.toLowerCase().indexOf('/account/') !== -1) {
          // hide the request head and body
          return null;
        }

        return request;
      },
    },
  });
}

async function renderApp() {
  const underMaintenance = await isUnderMaintenance();

  ReactDOM.render(
    underMaintenance ? (
      <Maintenance />
    ) : (
      <BrowserRouter>
        <App />
      </BrowserRouter>
    ),
    document.getElementById('root')
  );
}

renderApp();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
